import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import {
  MODAL_BANNER,
  MODAL_BANNER_MESSAGE_TYPE,
  MODAL_BANNER_TYPE,
} from './modal-error-banner.constants';

@Component({
  selector: 'app-modal-error-banner',
  templateUrl: './modal-error-banner.component.html',
  styleUrl: './modal-error-banner.component.scss',
  standalone: false,
})
export class ModalErrorBannerComponent {
  @Input({ required: true }) bannerType!: Signal<MODAL_BANNER_TYPE>;
  @Output() emitExit = new EventEmitter();

  readonly IMAGES = IMAGE_SRC;
  readonly BANNER_TYPE = MODAL_BANNER;
  readonly BANNER_MESSAGE_TYPE = MODAL_BANNER_MESSAGE_TYPE;
  readonly BANNER_400_MESSAGE = this.commonUtils.unknownBannerText;

  constructor(private commonUtils: CommonUtils) {}

  clickExit() {
    this.emitExit.emit();
  }
}
